import React, {useEffect} from 'react'
import Checkbox from 'components/Checkbox'

import {
    checkboxWrapper,
} from './styles'
import {styled} from 'stitches/config'

const StyledCheckboxWrapper = styled('div', checkboxWrapper)

export interface QuestionnaireCheckboxProps {
    id: string
    errorId?: string
    name: string
    readableName?: string
    groupName?: string
    text?: string
    description?: string
    value?: boolean
    onChange: (params: {name: string, value: boolean, readableName?: string, groupName?: string}, isInitial?: boolean) => void
}

export const QuestionnaireCheckbox = (props: QuestionnaireCheckboxProps) => {
    const {
        id, value, onChange, text, description, name, readableName, groupName, errorId, ...other
    } = props

    useEffect(() => {
        // set false value to all checkboxes by default to be send as metadata
        if (readableName) {
            onChange({
                groupName,
                name,
                readableName,
                value: value || false,
            }, true)
        }
    }, [readableName, value])

    const isErrorVisible = errorId ? document.getElementById(errorId)?.getAttribute('aria-hidden') === 'false' : false

    return (
        <StyledCheckboxWrapper>
            <Checkbox
                aria-invalid={isErrorVisible ? 'true' : 'false'}
                checked={value}
                description={description}
                id={id}
                label={text}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange({
                    groupName,
                    name,
                    readableName,
                    value: event.target.checked,
                }, false)}
                {...other}
            />
        </StyledCheckboxWrapper>
    )
}

QuestionnaireCheckbox.defaultProps = {
    description: '',
    errorId: '',
    groupName: '',
    readableName: '',
    text: '',
    value: false,
}
